<div
  class="top-div"
  [ngClass]="{ 'top-div-not-shared': !selectedItem?.isSharedWithMe }"
>
  <h1
    class="main-title"
    *ngIf="selectedItem?.id && !selectedItem?.isSharedWithMe"
  >
    Edit <span class="capitalize-text">{{ selectedItemType }}</span>
  </h1>
  <!-- can only edit if not shared with you and existing item -->
  <h1
    class="main-title"
    *ngIf="!selectedItem?.id && !selectedItem?.isSharedWithMe"
  >
    Add New <span class="capitalize-text">{{ selectedItemType }}</span>
  </h1>
  <!-- can add if not existing item and not shared with you (checking sharing just in case) -->
  <div *ngIf="selectedItem?.isSharedWithMe"></div>
  <!-- keeping the buttons fixed to the right -->
  <div class="top-btn-div">
    <p class="help-text success-message" *ngIf="isSaveSuccessful">
      Save successful!
    </p>
    <p class="help-text error-text" *ngIf="error && error == 409">
      Error: there is already a {{ selectedItemType }} with this name!
    </p>
    <p class="help-text error-text" *ngIf="error && error != 409">
      Action failed: contact
      <a
        href="https://illuminate.zendesk.com/hc/en-us/requests/new?ticket_form_id=21621854042395"
        target="_blank"
        title="Support"
        class="support-link"
        >support</a
      >
      for assistance.
    </p>
    <div *ngIf="!selectedItem?.isSharedWithMe">
      <!-- can only save own items -->
      <button
        data-id="ViewAndGroupModal.Save"
        mat-raised-button
        class="view-action-btn save-view-btn"
        (click)="saveViewEvent.emit(updatedItem)"
        alt="Save"
        [disabled]="checkSaveDisabled()"
        *ngIf="updatedItem && selectedItem && hasChangesToSave"
      >
        SAVE
      </button>
    </div>
  </div>
</div>
<div class="details-panel">
  <mat-card class="info-card" *ngIf="selectedItem?.isSharedWithMe"
    >This {{ selectedItemType }} is shared with you and cannot be
    edited.</mat-card
  >
  <div>
    <h1 class="view-title" *ngIf="selectedItem?.isSharedWithMe">
      {{ selectedItem?.name }}
    </h1>
    <text-area-input-element
      [label]="selectedItemType + ' name'"
      [rows]="1"
      [maxChars]="100"
      [value]="selectedItem?.name"
      [smallMargin]="true"
      [hasExternalError]="updatedItem?.name == '' || hasDuplicateViewName"
      (textAreaUpdated)="nameUpdated($event)"
      *ngIf="!selectedItem?.isSharedWithMe"
    >
      <!-- can only edit name of own views -->
    </text-area-input-element>
    <p class="modal-error" *ngIf="updatedItem?.name == ''">
      <span class="capitalize-text">{{ selectedItemType }}</span> name cannot be
      blank!
    </p>
    <p
      class="modal-error"
      *ngIf="hasDuplicateViewName && updatedItem?.name != ''"
    >
      View name cannot be the same as an existing view name!
    </p>
    <p
      class="modal-error"
      *ngIf="hasDuplicateGroupName && updatedItem?.name != ''"
    >
      Group name cannot be the same as an existing group name!
    </p>
  </div>
  <div>
    <p class="view-description" *ngIf="selectedItem?.isSharedWithMe">
      {{ selectedItem?.description }}
    </p>
    <text-area-input-element
      [label]="selectedItemType + ' description'"
      [rows]="3"
      [maxChars]="999"
      [value]="selectedItem?.description"
      [smallMargin]="true"
      (textAreaUpdated)="descriptionUpdated($event)"
      *ngIf="!selectedItem?.isSharedWithMe"
    >
      <!-- can only edit description of own views or groups -->
    </text-area-input-element>
  </div>
  <div *ngIf="selectedItemType == 'group'" class="group-criteria-div">
    <group-criteria
      [group]="updatedItem"
      [columns]="columns"
      [isAddGroup]="!selectedItem?.id && !selectedItem?.isSharedWithMe"
      (addCriteria)="addGroupCriteria($event)"
      (deleteCriteria)="deleteGroupCriteria($event)"
    ></group-criteria>
  </div>
  <div
    *ngIf="(isAdminUser || isSLUser) && !selectedItem?.isSharedWithMe"
    class="share-div"
  >
    <!-- can only share if admin/SL and own view or group -->
    <p class="heading-title">Share</p>
    <p class="share-description">
      Share the <span class="capitalize-text">{{ selectedItemType }}</span>
      <span *ngIf="selectedItemType == 'view'">
        (i.e., the criteria and sorting settings)
      </span>
      <span *ngIf="selectedItemType == 'group'">
        (i.e., the list of students and criteria settings)
      </span>
      with other users. Once shared, users will be able to select your Shared
      <span class="capitalize-text">{{ selectedItemType }}</span> on Our
      Students. Sharing a
      <span class="capitalize-text">{{ selectedItemType }}</span> does not alter
      in any way which students a user is allowed to access on Our Students.
      <span *ngIf="selectedItemType == 'view'">
        A Shared View simply applies the View's criteria to the user's existing
        list of students in Our Students.
      </span>
      <span *ngIf="selectedItemType == 'group'">
        A Shared Group simply filters the user's existing list of students by
        the Group’s criteria and students in the group.
      </span>
    </p>
    <div class="share-toggle-div mosaic-material-theme">
      <p class="share-label">
        {{ isStarterUser ? "District Admins" : "Schoolzilla Admins" }}
      </p>
      <mat-slide-toggle
        [(ngModel)]="sharedWithAdmins"
        (change)="sharedWithAdminsUpdated($event)"
      >
      </mat-slide-toggle>
      <p class="share-help-text" *ngIf="!sharedWithAdmins">Not shared</p>
      <p class="share-help-text" *ngIf="sharedWithAdmins">Shared</p>
    </div>
    <div class="share-toggle-and-select mosaic-material-theme">
      <div class="share-toggle-div">
        <p class="share-label">School Leaders</p>
        <mat-slide-toggle
          [(ngModel)]="sharedWithSchoolLeaders"
          (change)="toggleShareWithSchoolLeaders()"
        >
        </mat-slide-toggle>
        <p class="share-help-text" *ngIf="!sharedWithSchoolLeaders">
          Not shared
        </p>
        <p class="share-help-text" *ngIf="sharedWithSchoolLeaders">Shared</p>
      </div>
      <div>
        <multiselect-with-helpers
          [items]="schools"
          [bindLabel]="'officialSchoolName'"
          [groupBy]="'schoolLevel'"
          [placeholder]="'Select schools'"
          [selectedItems]="selectedSchoolLeaderSchools"
          (itemsSelected)="sharedWithSchoolLeaderSchoolsUpdated($event)"
          *ngIf="sharedWithSchoolLeaders"
        ></multiselect-with-helpers>
        <p
          class="modal-error"
          *ngIf="
            sharedWithSchoolLeaders &&
            (!updatedItem.sharedWithSchoolLeadersAtSchoolIds ||
              (updatedItem.sharedWithSchoolLeadersAtSchoolIds &&
                updatedItem.sharedWithSchoolLeadersAtSchoolIds.length == 0))
          "
        >
          Select at least one school!
        </p>
      </div>
    </div>
    <div
      class="share-toggle-and-select mosaic-material-theme"
      *ngIf="!isStarterUser"
    >
      <div class="share-toggle-div">
        <p class="share-label">Teachers</p>
        <mat-slide-toggle
          [(ngModel)]="sharedWithTeachers"
          (change)="toggleShareWithTeachers()"
        >
        </mat-slide-toggle>
        <p class="share-help-text" *ngIf="!sharedWithTeachers">Not shared</p>
        <p class="share-help-text" *ngIf="sharedWithTeachers">Shared</p>
      </div>
      <div>
        <multiselect-with-helpers
          [items]="schools"
          [bindLabel]="'officialSchoolName'"
          [groupBy]="'schoolLevel'"
          [placeholder]="'Select schools'"
          [selectedItems]="selectedTeacherSchools"
          (itemsSelected)="sharedWithTeacherSchoolsUpdated($event)"
          *ngIf="sharedWithTeachers"
        ></multiselect-with-helpers>
        <p
          class="modal-error"
          *ngIf="
            sharedWithTeachers &&
            (!updatedItem.sharedWithTeachersAtSchoolIds ||
              (updatedItem.sharedWithTeachersAtSchoolIds &&
                updatedItem.sharedWithTeachersAtSchoolIds.length == 0))
          "
        >
          Select at least one school!
        </p>
      </div>
    </div>
  </div>
  <div class="sort-filters-div" *ngIf="selectedItemType != 'group'">
    <student-sort-filters-display
      [studentSortFilters]="selectedItem"
      [columns]="columns"
    ></student-sort-filters-display>
  </div>
  <div class="num-students-div" *ngIf="selectedItemType == 'group'">
    <p class="heading-title">Number of Students</p>
    <ul>
      <li>
        {{
          selectedItem.studentsInGroup &&
          selectedItem.studentsInGroup.length > 0
            ? selectedItem.studentsInGroup.length
            : 0
        }}
      </li>
    </ul>
  </div>
  <div class="other-fields-div" *ngIf="selectedItem.id">
    <!-- Don't display when adding a new view or group -->
    <p class="heading-title">Other</p>
    <ul>
      <li>Created by: {{ selectedItem.ownerUserEmail }}</li>
      <li>Last updated: {{ selectedItem.lastUpdated }}</li>
    </ul>
  </div>
</div>
